import { User } from "./user";

export class Model {

  id?: number;
  createdBy?: User;
  createdAt?: Date;
  deletedAt?: Date;
  updatedAt?: Date;

}
